import axios from "axios";
import { apiErrorHandler } from "./helper/handler";

const prefix = "role-management";

const GET_ROLE_MANAGEMENT_BY_ROLE_ID_URL = `${prefix}/get-by-role-id`;

/**
 * Start
 * @func getRoleManagementById
 * @desc get role management by id
 * @author izeberg
 * @param {number} roleId - role id
 * @param {AbortSignal} signal - AbortController Signal
 * @returns {Array} role management array
 */
export const getRoleManagementByRoleId = async (roleId, signal) => {
    try {
        const { data, status } = await axios.get(`${GET_ROLE_MANAGEMENT_BY_ROLE_ID_URL}/${roleId}`, {
            signal,
        });
        if (status === 200) {
            return data;
        }
        return undefined;
    } catch (error) {
        const err = apiErrorHandler(error, "getRoleManagementById");
        if (err) throw err;
        return undefined;
    }
};
/** End @func getRoleManagementById */
